import { LocationType, type ResultsLocation } from '~/core/types'

export const resultsLocationValue = ({ type, value }: ResultsLocation) => {
  switch (type) {
    case LocationType.CITY:
      return value.code
    case LocationType.DEPARTMENT:
      return value.code
    case LocationType.REGION:
      return String(value?.id)
    case LocationType.COUNTRY:
      return value.code
    case LocationType.GOLF:
      return String(value.id)
    case LocationType.PROXIMITY:
      return `${value.latitude},${value.longitude}`
  }
}

export const resultsLocationLabel = ({ type, value }: ResultsLocation) => {
  switch (type) {
    case LocationType.CITY:
      return `${value.nom}, ${value.departement?.nom ?? ''}`
    case LocationType.DEPARTMENT:
      return `${value.nom}`
    case LocationType.REGION:
      return `${value?.name}`
    case LocationType.GOLF:
      return `${value.name}`
    case LocationType.COUNTRY:
      return `${value.label}`
    case LocationType.PROXIMITY:
      return `À proximité`
  }
}
